import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export interface UnifiedTheme {
  theme: {
    sys: {
      color: {
        canvas: {
          [200]?: string;
          default?: string;
        };
      };
    };
  };
}

interface ImprintText {
  marginBottom?: boolean;
}

export const ImprintContainer = styled.div`
  background-color: ${(props: UnifiedTheme) =>
    process.env.is_LEGACY && props.theme.sys.color.canvas.default};
  height: fit-content;
  margin: 0 auto;
  min-width: 0;
  max-width: 1024px;
  position: relative;
  width: auto;

  p,
  span,
  a,
  li {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

export const Content = styled.div`
  display: grid;
  height: 100%;
`;

export const ImprintText = styled(Text)<ImprintText>`
  margin-bottom: ${(props) => (props.marginBottom ? '12px' : '')};
`;
